import { render, staticRenderFns } from "./3dspinner.vue?vue&type=template&id=4a523c43&"
var script = {}
import style0 from "./3dspinner.vue?vue&type=style&index=0&id=4a523c43&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports